<template>
	<div class="brick">
		<label v-if="restriction_only_available" class="mgr_15"><input type="checkbox" v-model="restriction_only" @change="onStateReportChange" /> Restriction Only</label>
		<div class="list_top_box">
			<div class="left_option">
				<em class="lt_text">Base Date</em>
				<span class="mgr_5"> <CustomDatePicker v-model="base_date"/></span>
				<a href="javascript:void(0);" class="search_bt" @click="selectData()">Search</a>
				<a href="javascript:void(0);" class="gray_bt mgr_5" @click="reset()">Reset</a>
				<!-- <font color="red"><b>Base Date cannot be past.</b></font> -->
				<font color="red"><b>Takes very long time.</b></font>
			</div>
		</div>
		<div class="fixed-table-container">
			<div class="table-wrapper" style="height: 95%">
				<table class="list_tbl sticky_list_tbl" id="excelTable">
					<colgroup>
						<col style="width: 4%;" />
						<col style="width: 5%;" />
						<col />
						<col style="width: 7%;" />
						<col style="width: 7%;" />
						<col style="width: 7%;" />
						<col style="width: 7%;" />
						<col style="width: 7%;" />
						<col style="width: 7%;" />
						<col style="width: 7%;" />
						<col style="width: 7%;" />
						<col style="width: 7%;" />
						<col style="width: 7%;" />
						<col style="width: 7%;" />
						<col style="width: 7%;" />
					</colgroup>
					<thead>
						<tr>
							<th>No</th>
							<th>Bill To</th>
							<th>Bill To Name</th>
							<th>Invoice Date</th>
							<th>Invoice No</th>
							<th>Method</th>
							<th>Invoice Amount</th>
							<th>AR Balance</th>
							<th>0 ~ 30</th>
							<th>31 ~ 60</th>
							<th>61 ~ 90</th>
							<th>91 ~ 120</th>
							<th>121 ~ 150</th>
							<th>151 ~ 180</th>
							<th>OVER 181</th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="(invoice, index) in root.list" v-bind:key="index">
							<td class="al_center">{{ index + 1 }}</td>
							<template v-if="index == 0 || (index > 0 && invoice.invoice_no != root.list[index - 1].invoice_no)">
								<td>{{ invoice.bill_to_code }}</td>
								<td class="truncate">{{ invoice.bill_to_name }}</td>
								<td class="al_center">{{ invoice.invoice_date | moment('MM-DD-yyyy') }}</td>
								<td class="al_center">
									<a href="javascript:;" @click="selectInvoice(invoice)">{{ invoice.invoice_dn }}</a>
								</td>
								<td class="al_center">{{ invoice.payment_term_name }}</td>
								<td class="al_right">{{ invoice.invoice_amount | toCurrency }}</td>
								<!-- <td class="al_right">{{ invoice.post_check_balance | toCurrency }}</td> -->
								<td class="al_right">
									<a href="javascript:;" @click="gotoArHistory(invoice.bill_to_code, invoice.bill_to_name, invoice.invoice_no)">{{ invoice.post_check_balance | toCurrency }}</a>
								</td>
								<td class="al_right">{{ invoice.aging_date_0_30 | toCurrency }}</td>
								<td class="al_right">{{ invoice.aging_date_31_60 | toCurrency }}</td>
								<td class="al_right">{{ invoice.aging_date_61_90 | toCurrency }}</td>
								<td class="al_right">{{ invoice.aging_date_91_120 | toCurrency }}</td>
								<td class="al_right">{{ invoice.aging_date_121_150 | toCurrency }}</td>
								<td class="al_right">{{ invoice.aging_date_151_180 | toCurrency }}</td>
								<td class="al_right">{{ invoice.aging_date_181_0 | toCurrency }}</td>
							</template>
							<template v-else>
								<td colspan="12"></td>
							</template>
						</tr>
						<tr>
							<td colspan="6" class="al_right">Grand Total</td>
							<td class="al_right">{{ root.total_invoice_amount | toCurrency }}</td>
							<td class="al_right">{{ root.total_post_check_balance | toCurrency }}</td>
							<td class="al_right">{{ root.total_aging_date_0_30 | toCurrency }}</td>
							<td class="al_right">{{ root.total_aging_date_31_60 | toCurrency }}</td>
							<td class="al_right">{{ root.total_aging_date_61_90 | toCurrency }}</td>
							<td class="al_right">{{ root.total_aging_date_91_120 | toCurrency }}</td>
							<td class="al_right">{{ root.total_aging_date_121_150 | toCurrency }}</td>
							<td class="al_right">{{ root.total_aging_date_151_180 | toCurrency }}</td>
							<td class="al_right">{{ root.total_aging_date_181_0 | toCurrency }}</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>
		<div class="bottom_bt_box">
			<ul>
				<li>
					<a href="javascript:void(0);" v-on:click="excel">Excel</a>
				</li>
			</ul>
		</div>
	</div>
</template>

<script>
import stateReport from '@/mixins/stateReport';
import { apiArBalanceBySalesGroup } from '@/api/report/report';
import { apiGetReportTemplate, objectToFormData, Report, reportMrtUrl, exportDataExcel } from '@/api/util';
import { convertFalsyToEmpty } from '@/utils/etc';
import { defaultDataType } from 'export-xlsx';
import { today } from '@/utils/date';

import CustomDatePicker from '@/components/common/CustomDatePicker';

export default {
	mixins: [stateReport({ id: 'ArBalanceForCPA', search: 'selectData', queries: ['selectData'], results: ['root'] })],
	data: function() {
		return {
			root: '',
			base_date: today(),
		};
	},
	components: {
		CustomDatePicker,
	},
	methods: {
		selectInvoice(invoice) {
			if (invoice.invoice_type == 'A') return;
			else if (invoice.invoice_type != 'B' && !invoice.invoice_dn.startsWith('BC')) {
				// this.$router.push({ name: 'invoiceDetail', params: { mode: 'detail' }, query: this.stateReportQuery({ backUri: this.$route.fullPath, invoice_no: invoice.invoice_no }) });
				let routeData = this.$router.resolve({ name: 'invoiceDetail', params: { mode: 'detail' }, query: this.stateReportQuery({ backUri: this.$route.fullPath, invoice_no: invoice.invoice_no }) });
				window.open(routeData.href, '_blank');
			}
		},
		async gotoArHistory(partner_code, partner_name, invoice_no) {
			let routeData = this.$router.resolve({
				name: 'arHistory',
				query: this.stateReportQuery({ backUri: this.$route.fullPath, bill_to_code: partner_code, bill_to_name: partner_name, invoice_no: invoice_no, date_type_is_invoice: '1', all_date: '1' }),
			});
			window.open(routeData.href, '_blank');
		},
		async selectData() {
			const paramObj = {
				base_date: convertFalsyToEmpty(this.base_date),
			};
			const param = objectToFormData(paramObj);
			const { data } = await apiArBalanceBySalesGroup.call(this, param);
			this.root = data.value;
			//console.log(this.root.total_post_check_amount);
		},
		async index() {},
		async excel() {
			const state_output = this.captureStateReportOutput();
			if (!state_output) return;
			let data = null;
			if (this.root) {
				this.$toast.warning('Export to Excel takes time.', { duration: 3000 });

				if (Array.isArray(this.root.list)) data = [...this.root.list];
				else data = [];

				const total = {
					sales_group_code: 'TOTAL',
					invoice_amount: this.root.total_invoice_amount,
					receipt_amount: this.root.total_receipt_amount,
					post_check_balance: this.root.total_post_check_balance,
					aging_date_0_30: this.root.total_aging_date_0_30,
					aging_date_31_60: this.root.total_aging_date_31_60,
					aging_date_61_90: this.root.total_aging_date_61_90,
					aging_date_91_120: this.root.total_aging_date_91_120,
					aging_date_121_150: this.root.total_aging_date_121_150,
					aging_date_151_180: this.root.total_aging_date_151_180,
					aging_date_181_0: this.root.total_aging_date_181_0,
				};

				data.push(total);
			} else {
				this.$toast.error('No Data to Export.');
				return;
			}

			const headers = [
				{ key: 'sales_group_code', name: 'Sales Group Code', width: 15, dataType: defaultDataType.string },
				{ key: 'sales_group_name', name: 'Sales Group Name', width: 15, dataType: defaultDataType.string },
				{ key: 'invoice_date', name: 'Invoice Date', width: 15, dataType: defaultDataType.string },
				{ key: 'invoice_dn', name: 'Invoice No.', width: 15, dataType: defaultDataType.string },
				{ key: 'bill_to_code', name: 'Bill To', width: 15, dataType: defaultDataType.string },
				{ key: 'bill_to_name', name: 'Partner Name', width: 15, dataType: defaultDataType.string },
				{ key: 'address_detail', name: 'Address', width: 15, dataType: defaultDataType.string },
				{ key: 'address_city', name: 'City', width: 15, dataType: defaultDataType.string },
				{ key: 'address_state', name: 'State', width: 15, dataType: defaultDataType.string },
				{ key: 'address_zipcode', name: 'Zip', width: 15, dataType: defaultDataType.string },
				{ key: 'telephone', name: 'Telephone', width: 15, dataType: defaultDataType.string },
				{ key: 'country', name: 'Country', width: 15, dataType: defaultDataType.string },
				{ key: 'payment_term_code', name: 'PayType', width: 15, dataType: defaultDataType.string },
				{ key: 'payment_term_name', name: 'PayTypeName', width: 15, dataType: defaultDataType.string },
				{ key: 'invoice_amount', name: 'Invoice Amt.', width: 15, dataType: defaultDataType.number },
				{ key: 'receipt_amount', name: 'Close Amt.', width: 15, dataType: defaultDataType.number },
				{ key: 'post_check_balance', name: 'AR Balance', width: 15, dataType: defaultDataType.number },
				{ key: 'aging_date_0_30', name: '0 ~ 30', width: 15, dataType: defaultDataType.number },
				{ key: 'aging_date_31_60', name: '31 ~ 60', width: 15, dataType: defaultDataType.number },
				{ key: 'aging_date_61_90', name: '61 ~ 90', width: 15, dataType: defaultDataType.number },
				{ key: 'aging_date_91_120', name: '91 ~ 120', width: 15, dataType: defaultDataType.number },
				{ key: 'aging_date_121_150', name: '121 ~ 150', width: 15, dataType: defaultDataType.number },
				{ key: 'aging_date_151_180', name: '151 ~ 180', width: 15, dataType: defaultDataType.number },
				{ key: 'aging_date_181_0', name: 'Over 180', width: 15, dataType: defaultDataType.number },
			];

			if (!state_output.valid) return;

			exportDataExcel(data, headers, 'AR_balance_for_CPA');
		},
		async reportPrint() {
			const state_output = this.captureStateReportOutput();
			if (!state_output) return;
			this.root.type = 'print';
			const reportTemplate = await apiGetReportTemplate('ArBalanceForCPA', reportMrtUrl('ArBalanceForCPA'));
			const report = new Report(reportTemplate, this.root, 'ArBalanceForCPA');
			this.$store.commit('setReport', { ...report, state_scope_context: state_output });
		},
		reset() {
			this.base_date = today();
		},
		lineNumber() {
			this.itemIndex += 1;
			return this.itemIndex;
		},
	},
	computed: {},

	mounted() {
		this.$store.commit('setSideIndex', 7);
		this.$store.commit('setSelectedMenu', 'nav_li_ar_balance_for_cpa');
		this.$store.commit('setSubTitle', 'Report -> AR Balance For CPA');
		this.index();
	},
};
</script>

<style scoped></style>
